import PlaceholdeAvatar from './PlaceholderAvatar';

export default PlaceholdeAvatar;
